import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import type { PlaygroundNavParams } from '@euler/playground/Index';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { GalleryGrid } from './components/GalleryGrid';
import { GalleryLayout } from './components/GalleryLayout';
import { CategoryTile } from './components/index/CategoryTile';
import { kBiGalleryCategories } from './fixtures/biGalleryCategories';

/** The BI chart gallery's index: one tile per category. */
export const BiChartGalleryPage = wrapNavigatorScreen(
  () => {
    const navigation =
      useNavigation<StackNavigationProp<PlaygroundNavParams>>();
    return (
      <GalleryLayout
        title="BI 图表样式库"
        onBack={() =>
          navigation.canGoBack()
            ? navigation.goBack()
            : navigation.replace('Main', {})
        }
      >
        {({ width, palette }) => (
          <GalleryGrid
            width={width}
            items={kBiGalleryCategories}
            keyOf={category => category.key}
            render={(category, cell) => (
              <CategoryTile
                category={category}
                palette={palette}
                width={cell}
                onOpen={key =>
                  navigation.push('BiChartCategory', { category: key })
                }
              />
            )}
          />
        )}
      </GalleryLayout>
    );
  },
  { title: 'BI 图表样式库', headerShown: false, headerMode: 'float' },
);
